export function surveyTrade(state) {
  return state.trade;
}

export function surveyTradeItalian(state) {
  return state.tradeItalian;
}

export function surveyTradeSpanish(state) {
  return state.tradeSpanish;
}

export function surveyTradeFrench(state) {
  return state.tradeFrench;
}

export function surveyTradeNetherlands(state) {
  return state.tradeNL;
}

export function surveyTradeGermany(state) {
  return state.tradeDE;
}

export function surveyTradeUK(state) {
  return state.tradeUK;
}

export function surveyTradeNordics(state) {
  return state.tradeNO;
}
